export enum FastApiStatusCode {
  //成功状态码
  SuccessCode = 0,

  //请求相关异常异常
  ValidationError = 199000, // 内置校验错误
  TooManyRequests = 199001, // 请求过于频繁
  ClientDisconnect = 199002, // 客户端断开连接
  InvalidParam = 199003, // 请求参数异常
  Unauthorized = 199004, // 未经授权
  DatabaseOperationError = 199005, // 数据库操作错误
  RequestedDependencyNotExist = 199006, // 请求的依赖关系不存在
  RequestOrOperationConflict = 199007, // 请求或操作冲突
  DomainNotAllowed = 199008, // 域名被禁止
  DataStateConflict = 199011, // 数据状态冲突(如：工坊当前状态不允许审核)
  ProjectSpaceFailed = 100034, // 项目名称或项目编码已存在
  InsufficientPermission = 100035, // 用户权限不足，无权提交服务

  //后端资源相关异常
  DatabaseResourceNotExist = 198000, // 数据库资源不存在
  RedisResourceNotExist = 198001, // Redis资源不存在
  UpstreamRequestError = 198002, // 上游服务异常

  //用户模块相关异常
  PhoneNotBound = 100000, // 手机号未绑定
  ProtocolUpdate = 100001, // 用户协议更新，请重新登录
  RoleSelection = 100002, // 角色未选择
  UserNoRealNameAuthentication = 100003, // 目标用户未实名
  NoPermission = 100004, // 无操作权限
  UserBlocked = 100005, // 用户被封禁
  E_AntispamCheckError = 100006, // 易盾校验未通过
  NoPermissonNoJump = 100007, //无操作权限
  NickNameNotBound = 100008, //昵称未绑定
  TargetUserNoRealNameAuthentication = 100009, //目标用户未实名
  UserStillHasBalance = 100010, //用户还有余额
  UserNotExist = 100011, //用户不存在
  UserAlreadyEnterpriseAuthentication = 100012, //用户已经是企业认证用户
  UserNicknameChangeLimit = 100013, //昵称修改次数已用完
  EnterpriseValidationError = 100014, //企业打款校验失败
  UserNoArtistAuth = 100015, // 用户未认证创作者
  PlatformUpdate = 100018, // 平台升级说明更新

  PaymentInfoNotExist = 100020, //支付信息未绑定
  WithdrawProtocolUpdate = 100021, //提现协议更新
  OnSigning = 100022, //用户正在签约中

  // 分享ID已过期（通过shareId访问用户分享的关注创作者列表时使用）
  ExpiredSharing = 100023,

  YXBlackUsers = 104008, //用户在营销黑名单中
  YSBlackUsers = 104009, //用户在艺设黑名单中
  YSExclusiveUsers = 104010, //用户为艺设独家用户
  UserHasBeenDelete = 100024, //用户已下架
  EmailExist = 100026, //邮箱已存在
  PhoneExist = 100027, //手机号已存在

  VerifyCodeError = 100029, //验证码错误
  ArtworkNotVerify = 100033, //推荐作品未进行分类，无法移入美术作品
  CodeHasBeenSent = 100036, //验证码已发送

  //订单相关异常
  ZhongbaoUserNotExist = 112001, // 发包方数据异常，请让该用户重新登录有灵天工后再进行配置
  ZhongbaoUserInsufficientBalance = 112002, // 用户余额不足

  // 游戏账号相关
  GameNotSupport = 116001, // 请求游戏不支持查询
  GameAccountNotExist = 116002, // 当前账号未绑定手机号或邮箱号，无法查询

  //任务相关异常
  BackgroundVersionExpired = 104000, // 后台信息已过期，请通过任务详细查看版本提交信息
  EmptyReimbursementInformation = 104001, // 报销信息不能为空
  StageFinishTimeNotConfigured = 104011, //该项目组申请时需配置阶段预期完成时间
  HaveSameTypeTaskChange = 104012, //存在同类型的任务变更
  ExistPendingChangeApply = 104013, //存在待处理的需求变更，暂时不能发起结算
  VersionDuplicated = 104005, // 版本冲突

  //文件预签相关
  UnSupportedFileExt = 124001, // 不支持的文件后缀
  UnSupportedFileType = 124002, // 不支持的文件名

  // 工坊相关
  PleaseUpdateWorkshopDetails = 117001, // 请先修改工坊详情，再申请上架
  WorkshopLimitReached = 117002, // 工坊数量已达上限
  WorkshopSoldOut = 117003, // 工坊已售空
  WorkshopRemoved = 117004, // 工坊已下架
  WorkshopPriceChanged = 117005, // 工坊价格发生变动，请重新下单
  EnterpriseNotAllowed = 117006, // 企业用户不允许使用工坊
  ExceededMaxCapacity = 117007, // 稿件超出最大容量
  NoWorkshopInOpened = 117008, // 没有运营中的工坊
  NoAvailableDates = 117009, // 没有可预约精选的日期
  OverseasNotSupported = 117010, // 海外用户暂时无法使用工坊，敬请谅解
  FlashSaleLimitReached = 117011, // 您已达到本次活动可享受的秒杀次数上限，敬请谅解
  FlashSaleFailedButRegularAvailable = 117012, // 秒杀失败，但是可以购买常规库存
  FlashSaleFailedNoRegularAvailable = 117013, // 秒杀失败，无法购买常规库存
  FlashSaleNotWon = 117014, // 您没有抢到秒杀名额，请下次再来
  FlashSaleExpired = 117015, // 很遗憾，您的秒杀资格已过期，请下次及时支付哦

  // 活动相关
  NotInActivityTime = 118001, // 不在活动时间内
  NotInFlashSaleTime = 118002, // 不在秒杀时间内
  AlreadyRegistered = 118003, // 您已报名过该活动，请确认是否需要重复报名
  RegistrationLimitReached = 118004, // 已达报名次数上限
  NotInRegistrationTime = 118005, // 不在报名时间内
  //支付宝商户相关
  AlipayAccountNotConsistent = 100039, // 支付宝账号不一致
  MerchantNotSigned = 100042, // 支付宝账号未签约
}

export const FastApiErrorStatusCode = [
  //请求相关异常异常
  FastApiStatusCode.ValidationError, // 内置校验错误
  FastApiStatusCode.TooManyRequests, // 请求过于频繁
  FastApiStatusCode.ClientDisconnect, // 客户端断开连接
  FastApiStatusCode.InvalidParam, // 请求参数异常
  FastApiStatusCode.ProjectSpaceFailed, // 项目空间错误：项目名称或项目编码已存在
  FastApiStatusCode.InsufficientPermission, // 用户权限不足，无权提交服务

  FastApiStatusCode.Unauthorized, // 未经授权
  FastApiStatusCode.DatabaseOperationError, // 数据库操作错误
  FastApiStatusCode.RequestedDependencyNotExist, // 请求的依赖关系不存在
  FastApiStatusCode.RequestOrOperationConflict, // 请求或操作冲突
  FastApiStatusCode.DomainNotAllowed, // 域名被禁止
  FastApiStatusCode.DataStateConflict,
  FastApiStatusCode.VerifyCodeError, // 验证码校验失败
  FastApiStatusCode.PhoneExist, //手机号已存在
  FastApiStatusCode.NoWorkshopInOpened, // 没有运营中的工坊

  //后端资源相关异常
  FastApiStatusCode.DatabaseResourceNotExist, // 数据库资源不存在
  FastApiStatusCode.RedisResourceNotExist, // Redis资源不存在
  FastApiStatusCode.UpstreamRequestError, // 上游服务异常

  // 工坊和活动相关
  FastApiStatusCode.PleaseUpdateWorkshopDetails,
  FastApiStatusCode.NoAvailableDates,
  FastApiStatusCode.NotInActivityTime,
  FastApiStatusCode.NotInFlashSaleTime,
  FastApiStatusCode.AlreadyRegistered,
  FastApiStatusCode.RegistrationLimitReached,
  FastApiStatusCode.NotInRegistrationTime,
];

export const FastApiWarningStatusCode = [
  //用户模块相关异常

  FastApiStatusCode.UserNoRealNameAuthentication, // 目标用户未实名
  FastApiStatusCode.NoPermission, // 无操作权限
  FastApiStatusCode.UserBlocked, // 用户被封禁
  FastApiStatusCode.E_AntispamCheckError, // 易盾校验未通过
  FastApiStatusCode.NoPermissonNoJump, //无操作权限
  // FastApiStatusCode.NickNameNotBound, //昵称未绑定
  FastApiStatusCode.TargetUserNoRealNameAuthentication, //目标用户未实名
  FastApiStatusCode.UserStillHasBalance, //用户还有余额
  FastApiStatusCode.UserNotExist, //用户不存在
  FastApiStatusCode.UserAlreadyEnterpriseAuthentication, //用户已经是企业认证用户
  FastApiStatusCode.UserNicknameChangeLimit, //昵称修改次数已用完
  FastApiStatusCode.EnterpriseValidationError, //企业打款校验失败
  FastApiStatusCode.UserNoArtistAuth, // 用户未认证创作者

  //订单相关异常
  FastApiStatusCode.ZhongbaoUserNotExist, // 发包方数据异常，请让该用户重新登录有灵天工后再进行配置
  FastApiStatusCode.ZhongbaoUserInsufficientBalance, // 用户余额不足

  //任务相关异常
  FastApiStatusCode.BackgroundVersionExpired, // 后台信息已过期，请通过任务详细查看版本提交信息
  // FastApiStatusCode.EmptyReimbursementInformation, // 报销信息不能为空
  FastApiStatusCode.VersionDuplicated, // 版本冲突
];

export const FastApiStatusMessage = {
  [FastApiStatusCode.ValidationError]: '内置校验错误',
  [FastApiStatusCode.TooManyRequests]: '请求过于频繁',
  [FastApiStatusCode.ClientDisconnect]: '客户端断开连接',
  [FastApiStatusCode.InvalidParam]: '请求参数异常',
  [FastApiStatusCode.Unauthorized]: '未经授权',
  [FastApiStatusCode.DatabaseOperationError]: '数据库操作错误',
  [FastApiStatusCode.RequestedDependencyNotExist]: '请求的依赖关系不存在',
  [FastApiStatusCode.RequestOrOperationConflict]: '请求或操作冲突',
  [FastApiStatusCode.DomainNotAllowed]: '域名被禁止',
  [FastApiStatusCode.DataStateConflict]: '数据状态冲突',

  [FastApiStatusCode.DatabaseResourceNotExist]: '数据库资源不存在',
  [FastApiStatusCode.RedisResourceNotExist]: 'Redis资源不存在',
  [FastApiStatusCode.UpstreamRequestError]: '上游服务异常',

  [FastApiStatusCode.PhoneNotBound]: '手机号未绑定',
  [FastApiStatusCode.ProtocolUpdate]: '用户协议更新，请重新登录',
  [FastApiStatusCode.RoleSelection]: '角色未选择',
  [FastApiStatusCode.UserNoRealNameAuthentication]: '目标用户未实名',
  [FastApiStatusCode.NickNameNotBound]: '昵称未设置',
  [FastApiStatusCode.NoPermission]: '无操作权限',
  [FastApiStatusCode.UserBlocked]: '用户被封禁',
  [FastApiStatusCode.E_AntispamCheckError]: '易盾校验未通过',

  [FastApiStatusCode.NoPermissonNoJump]: '无操作权限',
  [FastApiStatusCode.TargetUserNoRealNameAuthentication]: '目标用户未实名',
  [FastApiStatusCode.UserStillHasBalance]: '用户还有余额',
  [FastApiStatusCode.UserNotExist]: '用户不存在',
  [FastApiStatusCode.UserAlreadyEnterpriseAuthentication]: '用户已经是企业认证用户',
  [FastApiStatusCode.UserNicknameChangeLimit]: '昵称修改次数已用完',
  [FastApiStatusCode.EnterpriseValidationError]: '企业打款校验失败',
  [FastApiStatusCode.UserNoArtistAuth]: '用户未认证创作者',

  [FastApiStatusCode.ZhongbaoUserNotExist]: '发包方数据异常，请让该用户重新登录有灵天工后再进行配置',
  [FastApiStatusCode.ZhongbaoUserInsufficientBalance]: '用户余额不足',

  [FastApiStatusCode.BackgroundVersionExpired]: '后台信息已过期，请通过任务详细查看版本提交信息',
  [FastApiStatusCode.EmptyReimbursementInformation]: '报销信息不能为空',
  [FastApiStatusCode.PlatformUpdate]: '平台更新说明',
  [FastApiStatusCode.UnSupportedFileExt]: '不支持的文件后缀',
  [FastApiStatusCode.UnSupportedFileType]: '不支持的文件名',

  [FastApiStatusCode.VerifyCodeError]: '验证码错误',
  [FastApiStatusCode.NoWorkshopInOpened]: '没有运营中的工坊',
};
